import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { constants } from "@cinch-nx/data-search";
import { createStore } from "zustand";
import { devtools } from "zustand/middleware";
import { convertRawSearchFiltersToSearchFilters, getUsedCarsUrlFilterHistoryFromSessionStorage, mapFiltersToUrl, setUsedCarsUrlFilterHistoryInSessionStorage } from "../../utils";
import { urlMiddleware } from "./url-middleware";
var facetDependants = new Map([
    [
        "make",
        [
            "model",
            "trim"
        ]
    ],
    [
        "model",
        [
            "trim"
        ]
    ], 
]);
export var initialiseSearchStore = function(param) {
    var params = param.params, isInsideStoryblok = param.isInsideStoryblok, isSsrUserAgentCinchApp = param.isSsrUserAgentCinchApp, allCinchStores = param.allCinchStores;
    var allCinchStoresLowercase = allCinchStores.map(function(value) {
        return value.toLowerCase();
    });
    var initialState = convertRawSearchFiltersToSearchFilters(params, allCinchStoresLowercase);
    if ("object" !== "undefined") {
        var initialUrl = mapFiltersToUrl(initialState, allCinchStoresLowercase);
        var usedCarsUrlFilterHistoryFromSessionStorage = getUsedCarsUrlFilterHistoryFromSessionStorage();
        setUsedCarsUrlFilterHistoryInSessionStorage(_object_spread_props(_object_spread({}, usedCarsUrlFilterHistoryFromSessionStorage), _define_property({}, initialUrl, initialState)));
    }
    return createStore(devtools(urlMiddleware(function(set, get) {
        return _object_spread_props(_object_spread({}, initialState), {
            isInsideStoryblok: isInsideStoryblok,
            isSsrUserAgentCinchApp: isSsrUserAgentCinchApp,
            allCinchStores: allCinchStores,
            allCinchStoresLowercase: allCinchStoresLowercase,
            getRawFilters: function getRawFilters() {
                return Object.entries(get()).reduce(function(acc, curr) {
                    var _curr = _sliced_to_array(curr, 2), key = _curr[0], value = _curr[1];
                    if (!Array.isArray(value) || value.length === 0) {
                        return acc;
                    }
                    acc[key] = value.join(",");
                    return acc;
                }, {});
            },
            updateFilter: function updateFilter(filter, value) {
                var newState = {
                    pageNumber: 1
                };
                // this clears a facets dependants. For example if a make is changed,
                // the facets 'model' and 'trim' will be cleared also as they depend on make.
                // Dependants are maintained in the `facetDependants` map
                if (facetDependants.has(filter)) {
                    var dependants = facetDependants.get(filter);
                    dependants === null || dependants === void 0 ? void 0 : dependants.forEach(function(dependant) {
                        return newState[dependant] = [];
                    });
                }
                if (filter === "make" || filter === "model") {
                    newState[filter] = value[0] === "" ? [] : value;
                } else if (filter === "store" && value[0] === "all-stores") {
                    newState.store = _to_consumable_array(get().allCinchStores);
                } else {
                    newState[filter] = value[0] === "-1" ? [] : value;
                }
                set(function(state) {
                    return _object_spread({}, state, newState);
                });
            },
            updateFilters: function updateFilters(filters) {
                set(function(state) {
                    return _object_spread({}, state, filters);
                });
            },
            clearFilterValue: function clearFilterValue(filterType, filterValue) {
                set(function(state) {
                    var newState = _define_property({
                        pageNumber: 1
                    }, filterType, state[filterType].filter(function(value) {
                        return value !== filterValue;
                    }));
                    // this clears a facets dependants. For example if a make is cleared,
                    // the facets 'model' and 'trim' will be cleared also as they depend on make.
                    // Dependants are maintained in the `facetDependants` map
                    if (facetDependants.has(filterType)) {
                        var dependants = facetDependants.get(filterType);
                        dependants === null || dependants === void 0 ? void 0 : dependants.forEach(function(dependant) {
                            return newState[dependant] = [];
                        });
                    }
                    return _object_spread({}, state, newState);
                });
            },
            clearAllFilters: function clearAllFilters() {
                set(function(state) {
                    return _object_spread_props(_object_spread({}, state, constants.defaultFilters), {
                        pageNumber: 1
                    });
                });
            },
            setPageNumber: function setPageNumber(page) {
                set(function(state) {
                    return _object_spread_props(_object_spread({}, state), {
                        pageNumber: page
                    });
                });
            },
            setPageSize: function setPageSize(size) {
                set(function(state) {
                    return _object_spread_props(_object_spread({}, state), {
                        pageSize: size,
                        pageNumber: 1
                    });
                });
            },
            setSortingCriteria: function setSortingCriteria(sortingCriteria) {
                set(function(state) {
                    return _object_spread_props(_object_spread({}, state), {
                        sortingCriteria: sortingCriteria,
                        pageNumber: 1
                    });
                });
            },
            setUseMonthly: function setUseMonthly(useMonthly) {
                set(function(state) {
                    return _object_spread_props(_object_spread({}, state), {
                        useMonthly: useMonthly,
                        toPrice: [],
                        fromPrice: [],
                        pageNumber: 1
                    });
                });
            },
            isCinchStoreDrawerOpen: false,
            setIsCinchStoreDrawerOpen: function setIsCinchStoreDrawerOpen(open) {
                set(function(state) {
                    return _object_spread_props(_object_spread({}, state), {
                        isCinchStoreDrawerOpen: open
                    });
                });
            }
        });
    }), {
        enabled: "production" === "development"
    }));
};
